/**
 * Thrown when a request cannot be retried because the user's session is over —
 * the identity provider rejected the refresh token, or there was nothing left to
 * refresh while a re-authentication was already pending. This is the ordinary end
 * of a session rather than a fault, and the auth service already redirects to the
 * login page on its own. A refresh that fails for any other reason — including
 * tokens that went missing with no redirect scheduled — keeps throwing a generic
 * error so that a real identity-provider outage, and a stuck signed-out tab, stay
 * visible.
 */
export class SessionExpiredError extends Error {
  constructor(message = 'Session expired') {
    super(message);

    // Set explicitly: class names do not survive minification, and both the
    // check below and Sentry's `ignoreErrors` entry match on the name.
    this.name = 'SessionExpiredError';
  }
}

export const isSessionExpiredError = (error: unknown): boolean =>
  error instanceof Error && error.name === 'SessionExpiredError';
